import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import Toggle from "react-toggle";
import {useSimTableActions} from "./useSimTableActions";

export const SimCard = ({data}) => {
  const {carrier, iccid, imei, status, activate, suspend, organization} = data;
  const {handleToggle} = useSimTableActions();
  return (
    <CardBody>
      <CardTitle tag="h3" data-cy={iccid}>
        <div>Carrier: {carrier}</div>
        <div>ICCID: {iccid}</div>
        <div>IMEI: {imei}</div>
      </CardTitle>
      <CardText>
        <div>STATUS: {status}</div>
        <div>ORGANIZATION: {organization}</div>
        <div className="d-flex mb-1">
          <span style={{marginRight: "10px"}}>ACTIVATE: </span>
          <span className={"sim-card-activate"}>
            <Toggle checked={activate} onChange={() => handleToggle(data, "activate")} />
          </span>
        </div>
        <div className="d-flex">
          <span style={{marginRight: "10px"}}>SUSPEND: </span>
          <span>
            <Toggle checked={suspend} onChange={() => handleToggle(data, "suspend")} />
          </span>
        </div>
      </CardText>
    </CardBody>
  );
};
